import { Component, app } from "modular-openscriptjs";
import { either, monetary } from "../../helpers";
import { dc } from "../../declarations";

const h = app("h");
const userCurrency = dc.userCurrency;

/**
 * Minimalist ProfileProductView component.
 * Redesigned to look exactly like SearchResultProductView (grid layout, shadow-based, borderless, rounded corners).
 * Handles attributes/styles merging by spreading ...args at the end of the root h.div children list.
 */
export class ProfileProductView extends Component {
	render(product, ...args) {
		if (!product?.id) return h.empty();

		const hasImage = product.images && product.images.length > 0;
		const imagePath = hasImage ? product.images[0].path : product.thumbnail_path;
		const finalHasImage = !!imagePath;

		const price = product.final_price || product.selling_price || product.price;

		return h.div(
			{
				class: "profile-product-card overflow-hidden rounded-4 bg-white transition-all",
				style: `
					display: grid; 
					min-height: 120px; 
					box-shadow: 0 4px 20px rgba(0,0,0,0.05); 
					cursor: pointer;
				`,
			},
			either(
				finalHasImage,
				() => [
					// Image section
					h.div(
						{
							class: "position-relative overflow-hidden rounded-bottom-4",
							style: "background: #f8f9fa; height: 100%;",
						},
						h.img({
							src: imagePath,
							class: "w-100 h-100 object-fit-cover",
							alt: product.name,
							loading: "lazy",
						})
					),
					// Content section (Right)
					h.div(
						{
							class: "py-2 px-3 d-flex flex-column justify-content-between",
						},
						h.div(
							h.h6(
								{
									class: "fw-bold text-dark mb-1 text-truncate-2-lines",
									style: "font-size: 0.88rem; line-height: 1.3;",
								},
								product.name
							)
						),
						h.div(
							{ class: "fw-bold text-primary", style: "font-size: 0.9rem;" },
							monetary(price, userCurrency)
						)
					)
				],
				() => [
					// Content section (Full Width)
					h.div(
						{
							class: "py-3 px-3 d-flex flex-column justify-content-between h-100",
						},
						h.div(
							h.h6(
								{
									class: "fw-bold text-dark mb-1 text-truncate-2-lines",
									style: "font-size: 0.88rem; line-height: 1.3;",
								},
								product.name
							),
							either(
								product.description,
								() => h.p(
									{
										class: "text-muted small mb-2",
										style: "font-size: 0.75rem; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; line-height: 1.4;",
									},
									product.description.replace(/<[^>]*>/g, '') // strip html tags
								)
							)
						),
						h.div(
							{ class: "fw-bold text-primary mt-2", style: "font-size: 0.9rem;" },
							monetary(price, userCurrency)
						)
					)
				]
			),
			...args
		);
	}
}
